import React from 'react';
import '../SummaryCard.scss';
import useStore, { IStore } from 'app/store';
import { Text, FontIcon } from '@fluentui/react';
import { ListFolderDto, ListQueryDto } from 'generated/user-backend';
import { iconOptions } from '../../listBuilder/options/Options';
import noLists from 'app/static/icons/NoLists.svg';
import { ListCount, RequestDto } from 'generated/request-backend';
import { StateData } from '../../manageRequests/ManageRequests';

interface IProps {
    folderData: ListFolderDto;
    stateData: StateData;
    listSummary: ListCount[];
}

const ListBuilderCardFolder: React.FC<IProps> = ({ folderData, listSummary }) => {
    const requestType = useStore((state: IStore) => state.requestType);
    const listId = useStore((state: IStore) => state.listId);
    const setLastSelectedRequest = useStore((state: IStore) => state.setLastSelectedRequest);
    const setRequestType = useStore((state: IStore) => state.setRequestType);
    const setListBuilderFilters = useStore((state: IStore) => state.setListBuilderFilters);
    const setFilterPanelDisabled = useStore((state: IStore) => state.setFilterPanelDisabled);
    const setListIcon = useStore((state: IStore) => state.setListIcon);
    const setListId = useStore((state: IStore) => state.setListId);

    const handleSetSelectedCard = (list: ListQueryDto) => {
        setLastSelectedRequest({} as RequestDto);
        setRequestType(list.queryName);
        setListBuilderFilters(list.queryFilters);
        setFilterPanelDisabled(true);
        setListIcon(iconOptions[list.icon].imageSrc);
        setListId(list.id);
    };

    const setActiveCard = (type: string, id: string) => {
        return requestType === type && listId === id ? 'active' : '';
    };

    return (
        <div className="lb-card-folder">
            <div className="lb-card-folder-name">
                <FontIcon iconName="OpenFolderHorizontal" className="lb-folder-icon" /> 
                <Text className="lb-card-folder-text">{folderData.name}</Text>
            </div>
            <div className="lb-list-container">
                {folderData.savedListQueries.length > 0 ? folderData.savedListQueries.map((list, index) => (
                    <div key={index} className={`lb-card-list ${setActiveCard(list.queryName, list.id)}`} onClick={() => handleSetSelectedCard(list)}>
                        <img className={`lb-card-list-icon`} src={setActiveCard(list.queryName, list.id) === 'active' ? iconOptions[list.icon].selectedImageSrc : iconOptions[list.icon].imageSrc} alt="list icon" />
                        <Text className="lb-card-list-name">{list.queryName}</Text>
                        <Text className="lb-card-list-count" variant="mediumPlus">{listSummary?.find((item: ListCount) => item.queryId === list.id).count ? listSummary?.find((item: ListCount) => item.queryId === list.id).count : '0'}</Text>
                    </div>
                )) : (
                    <div className={`lb-no-list`}>
                        <img className="lb-card-list-icon" src={noLists} alt="No Lists in this folder" />
                        <Text className="lb-card-no-content">No lists in this folder</Text>
                    </div>
                )}
            </div>
        </div>
    )
}

export default ListBuilderCardFolder;